// Service-area pages data. Copy is verbatim from the brief; titles get
// " | Flow Forge Mechanical" appended at render time.

// Map of service labels -> existing service page paths.
export const SERVICE_LINKS = {
  'water heater replacement': '/plumbing/water-heater-replacement-calgary',
  'furnace repair': '/heating/furnace-repair-calgary',
  'gas line installation': '/gas-fitting/gas-line-installation-calgary',
  'garage heaters': '/heating/garage-heaters-calgary',
  'BBQ gas lines': '/gas-fitting/bbq-gas-lines-calgary',
  'boiler & hydronic heating': '/heating/boiler-hydronic-calgary',
  'Poly-B replacement': '/plumbing/poly-b-replacement-calgary',
  'gas appliance installation': '/gas-fitting/gas-appliance-installation-calgary',
  'drain cleaning': '/plumbing/drain-cleaning-calgary',
  'gas fireplaces': '/gas-fitting/gas-fireplace-calgary',
  'in-floor radiant heating': '/heating/in-floor-radiant-heating-calgary',
  'furnace installation & repair': '/heating/furnace-installation-repair-calgary',
};

export const SERVICE_AREAS = [
  {
    slug: 'airdrie',
    name: 'Airdrie',
    areaKey: 'airdrie',
    title: 'Plumbing & Gas Fitting in Airdrie',
    meta: 'Water heaters, garage heaters, gas lines and furnace repair in Airdrie, north of Calgary, by our licensed, insured team.',
    h1: 'Plumbing, Heating & Gas Fitting in Airdrie',
    p1: 'Airdrie sits just north of Calgary on the Queen Elizabeth II Highway, within Calgary and Surrounding Areas. Homeowners here call us for hot water tank replacements, furnace repairs and new gas lines.',
    p2: 'Gas and plumbing permits in Airdrie are issued by the City of Airdrie.',
    services: ['water heater replacement', 'furnace repair', 'gas line installation', 'garage heaters', 'BBQ gas lines'],
  },
  {
    slug: 'cochrane',
    name: 'Cochrane',
    areaKey: 'cochrane',
    title: 'Plumbing & Heating in Cochrane',
    meta: 'Gas fitting, garage heaters, water heaters and boiler service in Cochrane, west of Calgary.',
    h1: 'Plumbing, Heating & Gas Fitting in Cochrane',
    p1: "Cochrane is about 18 km west of Calgary's city limits along Highway 1A. We travel out for gas lines, garage heaters, hot water tanks and boiler and hydronic heating work.",
    p2: 'The Town of Cochrane handles plumbing and gas permits, and gas permits there must be taken out by a certified gas fitter.',
    services: ['gas line installation', 'garage heaters', 'water heater replacement', 'boiler & hydronic heating', 'furnace repair'],
  },
  {
    slug: 'okotoks',
    name: 'Okotoks',
    areaKey: 'okotoks',
    title: 'Plumbing & Gas Fitting in Okotoks',
    meta: 'Hot water tanks, Poly-B replacement, furnace repair and gas lines in Okotoks, south of Calgary.',
    h1: 'Plumbing, Heating & Gas Fitting in Okotoks',
    p1: 'Okotoks sits on the Sheep River, roughly 38 km south of downtown Calgary. We serve Okotoks homes for hot water tank replacement, Poly-B replacement, furnace repair and gas appliance hookups.',
    p2: 'Plumbing and gas permits in Okotoks go through the Town of Okotoks.',
    services: ['water heater replacement', 'Poly-B replacement', 'furnace repair', 'gas appliance installation', 'drain cleaning'],
  },
  {
    slug: 'chestermere',
    name: 'Chestermere',
    areaKey: 'chestermere',
    title: 'Plumbing & Heating in Chestermere',
    meta: 'Gas lines, BBQ and fireplace hookups, water heaters and furnace repair in Chestermere, just east of Calgary.',
    h1: 'Plumbing, Heating & Gas Fitting in Chestermere',
    p1: 'Chestermere borders Calgary on the east and surrounds Chestermere Lake. We handle gas lines for BBQs and fireplaces, hot water tanks, furnace repairs and in-floor heating for homes here.',
    p2: 'The City of Chestermere issues its own plumbing and gas permits.',
    services: ['BBQ gas lines', 'gas fireplaces', 'water heater replacement', 'furnace repair', 'in-floor radiant heating'],
  },
  {
    slug: 'strathmore',
    name: 'Strathmore',
    areaKey: 'strathmore',
    title: 'Plumbing & Gas Fitting in Strathmore',
    meta: 'Water heaters, garage heaters, gas lines and furnace work in Strathmore, east of Calgary on the Trans-Canada.',
    h1: 'Plumbing, Heating & Gas Fitting in Strathmore',
    p1: 'Strathmore is about 50 km east of Calgary along the Trans-Canada Highway. We make the drive for hot water tank replacements, garage heaters, gas lines and furnace work.',
    p2: 'The Town of Strathmore issues gas and plumbing permits; Park Enterprises does its inspections.',
    services: ['water heater replacement', 'garage heaters', 'gas line installation', 'furnace installation & repair', 'Poly-B replacement'],
  },
  {
    slug: 'high-river',
    name: 'High River',
    areaKey: 'high-river',
    title: 'Plumbing & Gas Fitting in High River',
    meta: 'Water heaters, furnace repair, gas lines and garage heaters in High River, south of Calgary on Highway 2.',
    h1: 'Plumbing, Heating & Gas Fitting in High River',
    p1: 'High River is about 68 km south of Calgary, where Highways 2 and 23 meet, with the Highwood River running through town. We make the drive for hot water tank replacements, furnace repairs, gas lines and garage heaters.',
    p2: 'Plumbing and gas permits in High River are issued by the Town of High River, through its online e-permitting portal.',
    services: ['water heater replacement', 'furnace repair', 'gas line installation', 'garage heaters', 'Poly-B replacement'],
  },
  {
    slug: 'rocky-view-county',
    name: 'Rocky View County',
    areaKey: 'rocky-view-county',
    title: 'Acreage Gas Lines & Heating, Rocky View County',
    meta: 'Gas lines to shops and garages, garage heaters, water heaters and Poly-B replacement for Rocky View County acreages.',
    h1: 'Gas Fitting & Plumbing for Rocky View County Acreages',
    p1: 'Rocky View County wraps around most of Calgary, and is mostly rural with many country residential acreages. We run gas lines out to shops and detached garages, install garage heaters, and replace hot water tanks and Poly-B piping on acreage homes.',
    p2: "County gas and plumbing permits go through Rocky View County's myBuild portal. We take out the required permits for the work.",
    services: ['gas line installation', 'garage heaters', 'water heater replacement', 'Poly-B replacement'],
  },
];

export const getServiceArea = (slug) => SERVICE_AREAS.find((a) => a.slug === slug);
